import database from '../database/db.json';

export const useDatabase = () => database;